export default "__VITE_ASSET__C11xthwM__"